import { jsxs as u, jsx as f } from "react/jsx-runtime";
import "../../base-nYmjnkiN.js";
import { useRef as S, useState as _, useMemo as b } from "react";
import k from "../../core/hooks/useOutsideClick.js";
import w from "../../core/hooks/useUuid.js";
import { capitalize as D } from "../../core/utils/string.js";
import { cssX as r } from "../../core/utils/css.js";
import { c as l } from "../../index-C7ezJk5b.js";
import $ from "../Dropdown/Dropdown.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
const A = ({
  options: t,
  value: d,
  setValue: n,
  isDisabled: h = !1,
  style: p,
  className: N,
  testId: m
}) => {
  const i = w(), c = S(null), [o, a] = _(!1);
  k({
    ref: c,
    callback: () => a(!1)
  });
  const s = b(
    () => t.find((e) => e.id === d),
    [t, d]
  );
  return /* @__PURE__ */ u(
    "div",
    {
      ref: c,
      className: l(
        r("CountriesSelect"),
        h && "is-disabled",
        N
      ),
      style: p,
      "data-testid": m,
      children: [
        /* @__PURE__ */ f(
          "div",
          {
            className: l(r("CountriesSelect__thumb")),
            "data-tooltip-id": i,
            onClick: () => a(!o),
            children: (s == null ? void 0 : s.thumbName) ?? (s == null ? void 0 : s.shortName) ?? "Select country"
          }
        ),
        /* @__PURE__ */ f(
          $,
          {
            id: i,
            isOpened: o,
            testId: `${m}Dropdown`,
            columns: [
              {
                id: i,
                title: "",
                items: t.map((e, C) => ({
                  id: e.id,
                  content: /* @__PURE__ */ u(
                    "div",
                    {
                      className: l(
                        r("Dropdown__item"),
                        "is-tall",
                        "is-pad-left",
                        r("CountriesSelect__option"),
                        e.className,
                        e.id === (s == null ? void 0 : s.id) && "is-selected"
                      ),
                      style: e.style,
                      "data-testid": `${m}DropdownItem${D(e.name || e.shortName || `${C}`, !0)}`,
                      onClick: () => {
                        n(e.id), a(!1);
                      },
                      children: [
                        e.shortName,
                        " - ",
                        e.name,
                        e.children
                      ]
                    }
                  )
                }))
              }
            ]
          }
        )
      ]
    }
  );
};
export {
  A as default
};
